import { render, staticRenderFns } from "./ToastWrapper.vue?vue&type=template&id=5b3c66e2&"
import script from "./ToastWrapper.vue?vue&type=script&lang=js&"
export * from "./ToastWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports